import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateFolderEntryInput,
  UpdateFolderEntryMutation,
} from '@/gql/graphql';

const UPDATE_FOLDER_ENTRY_MUTATION = graphql(`
  mutation UpdateFolderEntry($input: UpdateFolderEntryInput!) {
    updateFolderEntry(input: $input) {
      id
      name
    }
  }
`);

const useUpdateFolderEntry = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    UpdateFolderEntryMutation,
    unknown,
    UpdateFolderEntryInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_FOLDER_ENTRY_MUTATION, { input });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folders(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useUpdateFolderEntry;
